import ClickOutside from "./ClickOutside";

export default ClickOutside;
